import './Header.css';

const isHomepage =
  typeof window !== 'undefined' &&
  (window.location.pathname === '/' || window.location.pathname === '');

export default function Header() {
  const logoHref = isHomepage ? 'https://lovinmalta.com' : '/';
  const logoTarget = isHomepage ? '_blank' : undefined;
  const logoRel = isHomepage ? 'noopener noreferrer' : undefined;

  return (
    <header className="site-header">
      <div className="site-header__inner">
        <a
          href={logoHref}
          target={logoTarget}
          rel={logoRel}
          className="site-header__brand"
          aria-label={isHomepage ? 'Visit Lovin Malta' : 'Back to homepage'}
        >
          <img
            src="/assets/lovin-malta-logo.png"
            alt="Lovin Malta"
            className="site-header__logo"
          />
        </a>
        <span className="site-header__divider" aria-hidden="true" />
        <span className="site-header__tag">Election 2026</span>
        <nav className="site-header__nav" aria-label="Primary">
          <a href="/surveys">Polls</a>
          <a href="/#proposals">Proposals</a>
          <a href="/#candidates">Candidates</a>
          <a href="/#quiz">Quiz</a>
          <a href="/#map">Map</a>
          <a href="/ai_manifesto">Manifestos</a>
          <a href="/district_analysis">Districts Analysis</a>
          {/* Know Before You Vote nav link disabled — uncomment when ready
              to launch the dedicated /know-before-you-vote section. The
              homepage carousel is feature-flagged separately as
              'featured_candidate' in /admin/flags. */}
          {/* <a href="/know-before-you-vote">Know Before You Vote</a> */}
        </nav>
      </div>
    </header>
  );
}
